'use strict'
// Template version: 1.3.1
// see http://vuejs-templates.github.io/webpack for documentation.

const path = require('path')

module.exports = {

  // Globals - FHabian
  baseUrl: 'https://hs-' + process.env.NODE_ENV + '-fhabian-patient-api.azurewebsites.net',
  callbackUri: '/welcome',
  bankIdUri: '/login/bankid',
  frejaUri: '/login/freja',
  sessionUri: '/session',
  tokenTestUri: '/token/test',
  tokenBankIdUri: '/token/bankid',
  tokenFrejaUri: '/token/freja',
  verifyPhoneStartUri: '/verifyphone/start',
  verifyPhoneCheckUri: '/verifyphone/check',
  relativeUri: '/relative',
  consentUri: '/consent',
  cardioDecisionUri: '/cardiodecision',
  secondaryCaregiverUri: '/secondarycaregiver',
  consentScreeningUri: '/consentscreening',
  consentResearchUri: '/consentresearch',
  screeningUri: '/screening',
  researchUri: '/research',
  allChildrenUri: '/allchildren',
  childrenUnder13Uri: '/childrenunder13',
  childrenbetween13and15Uri: '/childrenbetween13and15',
  testresultsUri: '/testresults',
  inviteUri: '/invite',
  mutationUri: '/mutation',
  diagnosisUri: '/diagnosis',
  bloodtestassessmentUri: '/bloodtestassessment',
  bloodtestUri: '/bloodtest',
  gentestUri: '/genetictest',
  diagnosisUri: '/diagnosis',
  referralUri: '/referral',
  registrationUri: '/registration',
  referralHealthcenterUri: '/referral/healthcenter',
  medicalRecordsUri: '/medicalrecords',
  contactRelativeHospitalUri: '/contactrelativeforhospitalinfo',
  orderMedicalRecordsUri: '/ordermedicalrecords',
  screeningAnswerUri: '/screeninganswer',
  msInterval: 4444,
  msPutRelative: 5555,
  datoDev: 'd72b8825d76d7fbb6a55cf41bff39f',
  datoProd: '2a84aacd0cef2957fbc9bef03f362d',

  dev: {
    // Paths
    assetsSubDirectory: 'static',
    assetsPublicPath: '/',
    proxyTable: {},

    // Various Dev Server settings
    host: 'localhost', // can be overwritten by process.env.HOST
    port: 8080, // can be overwritten by process.env.PORT, if port is in use, a free one will be determined
    autoOpenBrowser: false,
    errorOverlay: true,
    notifyOnErrors: true,
    poll: false, // https://webpack.js.org/configuration/dev-server/#devserver-watchoptions-

    // Use Eslint Loader?
    // If true, your code will be linted during bundling and
    // linting errors and warnings will be shown in the console.
    useEslint: true,
    // If true, eslint errors and warnings will also be shown in the error overlay
    // in the browser.
    showEslintErrorsInOverlay: false,

    /**
     * Source Maps
     */

    // https://webpack.js.org/configuration/devtool/#development
    devtool: 'cheap-module-eval-source-map',

    // If you have problems debugging vue-files in devtools,
    // set this to false - it *may* help
    // https://vue-loader.vuejs.org/en/options.html#cachebusting
    cacheBusting: true,

    cssSourceMap: true
  },

  build: {
    // Template for index.html
    index: path.resolve(__dirname, '../dist/index.html'),

    // Paths
    assetsRoot: path.resolve(__dirname, '../dist'),
    assetsSubDirectory: 'static',
    assetsPublicPath: '/',

    /**
     * Source Maps
     */

    productionSourceMap: true,
    // https://webpack.js.org/configuration/devtool/#production
    devtool: '#source-map',

    // Gzip off by default as many popular static hosts such as
    // Surge or Netlify already gzip all static assets for you.
    // Before setting to `true`, make sure to:
    // npm install --save-dev compression-webpack-plugin
    productionGzip: false,
    productionGzipExtensions: ['js', 'css'],

    // Run the build command with an extra argument to
    // View the bundle analyzer report after build finishes:
    // `npm run build --report`
    // Set to `true` or `false` to always turn it on or off
    bundleAnalyzerReport: process.env.npm_config_report
  }
}



//////////////////
// WEBPACK FOOTER
// ./config/index.js
// module id = FhoZ
// module chunks = 1